var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50091 8.49961L1.58425 5.58294C1.25925 5.25794 0.742578 5.25794 0.417578 5.58294C0.0925781 5.90794 0.0925781 6.42461 0.417578 6.74961L3.90925 10.2413C4.23425 10.5663 4.75925 10.5663 5.08425 10.2413L13.9176 1.41628C14.2426 1.09128 14.2426 0.574609 13.9176 0.249609C13.5926 -0.0753906 13.0759 -0.0753906 12.7509 0.249609L4.50091 8.49961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleDone);
export default __webpack_public_path__ + "static/media/simpleDone.218198bd.svg";
export { ForwardRef as ReactComponent };